import { useEffect, useState, useRef } from "react";
import DataTable from "../../../Components/DataTable/DataTable";
import {
  ButtonAdd,
  ButtonEdit,
  ButtonOther,
} from "../../../Components/Button/Button";
import Loading from "../../../Components/Loading/Loading";
import { useRecoilValue, useRecoilState } from "recoil";
import { userData } from "../../../DataContext/DataContext";
import { AlertError } from "../../../Components/AlertDialog/AlertDialog";
import axios from "axios";
import { authorization, UrlApi } from "../../../UrlApi/UrlApi";
import Card from "@mui/material/Card";
import AddUserData from "./AddUserData";
import * as SiIcons from "react-icons/si";
import { CSVLink } from "react-csv";
import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment, IconButton } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { TextInput } from "../../../Components/Input/Input";
import { useParams } from "react-router-dom";

function UserData(props) {
  const { type_id, menu_name} = useParams(); 
  const [openDialogformEdit, setOpenDialogFormEdit] = useState(false);
  const [openDialogformAdd, setOpenDialogFormAdd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(50);
  const [countRowData, setCountRowData] = useState(0);
  const [page, setPage] = useState(0);
  const user = useRecoilValue(userData);
  const [employeeData, setEmployeeData] = useState([]);
  const [dataExport, setDataExport] = useState([]);
  const [empId, setEmpId] = useState("");
  const [search, setSearch] = useState("");

  const getData = async () => {
    setLoading(true);
    await axios
      .post(UrlApi + "get_employee_data", {type_id}, authorization)
      .then((res) => {
        res.data.map((item, index) => {
          item.list_no = index + 1;
        });
        setEmployeeData(res.data);
        exportExcells(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        AlertError(err);
      });
  };

  useEffect(() => {
    document.addEventListener("keydown", detextKeyDown, true);
    getData();
  }, [openDialogformEdit === false, openDialogformAdd === false]);

  const detextKeyDown = (e) => {
    if (e.key === "F9") {
      setOpenDialogFormAdd(true);
      return false;
    }
  };

  const columns = [
    {
      title: "ลำดับ",
      field: "list_no",
      filtering: false,
      headerStyle: {
        width: "10px",
        maxWidth: "10px",
      },
      cellStyle: { width: "5px", maxWidth: "5px" },
    },
    {
      title: "เปิด",
      field: "emp_master_id",
      filtering: false,
      export: false,
      headerStyle: {
        width: "5px",
        maxWidth: "5px",
      },
      cellStyle: { width: "5px", maxWidth: "5px" },
      render: (rowData) => (
        <ButtonEdit
          onClick={() => {
            setEmpId(rowData.emp_master_id);
            setOpenDialogFormEdit(true);
          }}
        />
      ),
    },
    {
      title: "รหัสพนักงาน",
      field: "emp_code",
      headerStyle: {
        width: "5%",
        maxWidth: "5%",
        height: "10px",
      },
      cellStyle: { width: "5%", maxWidth: "5%" },
    },
    {
      title: "ชื่อ",
      field: "emp_firstname",
      headerStyle: {
        width: "10%",
        maxWidth: "10%",
      },
      cellStyle: { width: "10%", maxWidth: "10%" },
    },
    {
      title: "นามสกุล",
      field: "emp_lastname",
      headerStyle: {
        width: "10%",
        maxWidth: "10%",
      },
      cellStyle: { width: "10%", maxWidth: "10%" },
    },
    {
      title: "ชื่อเล่น",
      field: "emp_nickname",
      headerStyle: {
        width: "5%",
        maxWidth: "5%",
      },
      cellStyle: { width: "5%", maxWidth: "5%" },
    },
    {
      title: "เบอร์โทร",
      field: "emp_tel",
    },
  ];

  const filteredItems = employeeData.filter(
    item => JSON.stringify(item).toLowerCase().indexOf(search.toLowerCase().trim()) !== -1
  );

  const HeaderPage = () => {
    return (
      <>
        <div style={{ paddingTop: "10px" }}>
          <label style={{ marginLeft: "10px", fontSize: "18px" }}>
            {menu_name}
          </label>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <ButtonAdd
              label="เพิ่ม"
              variant="contained"
              onClick={() => {
                setOpenDialogFormAdd(true);
              }}
            />
            <div style={{ marginRight: "5px", marginTop: "2px", display: 'flex', width: '50%', justifyContent: 'flex-end'}}>
            <TextInput
                width="100%"
                placeholder="ค้นหา ชื่อพนักงาน, รหัสพนักงาน"
                onKeyDown={(e) => {}}
                value={search}
                onChange={(e) => {              
                  setSearch(e.target.value);                
                }}
                startAdornment={
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => {
                        setSearch("");                     
                      }}
                      edge="end"
                    >
                      <CancelIcon />
                    </IconButton>
                  </InputAdornment>
                }
              />
              <CSVLink
                style={{
                  textDecoration: "none",
                  justifyContent: "flex-end",
                  width: '20px',
                  marginLeft: '130px'
                }}
                data={dataExport}
                filename={"ข้อมูลพนักงาน DGF Express.csv"}
                target="_blank"
              >
                {
                  <ButtonOther
                    onClick={() => {}}
                    message="ส่งออก"
                    width="15ch"
                    startIcon={<SiIcons.SiMicrosoftexcel />}
                  />
                }
              </CSVLink>
            </div>
          </div>
        </div>
      </>
    );
  };

  const exportExcells = (employeeData) => {
    let columnExport = [];
    columns.map((item) => {
      if (item.title !== "เปิด") {
        columnExport.push(item.title);
      }
    });
    const csvData = [
      ["", "", "", ""],
      ["", "", "", "ข้อมูลพนักงาน DGF Express"],
      columnExport,
    ];
    let data = [];
    employeeData.map((item) => {
      data = [
        item.list_no,
        item.emp_code,
        item.emp_firstname,
        item.emp_lastname,
        item.emp_nickname,
        item.emp_tel,
      ];
      csvData.push(data);
    });
    setDataExport(csvData);
  };

  return (
    <>
      <Card
        variant="outlined"
        style={{
          paddingLeft: "10px",
          paddingRight: "10px",
          borderRadius: "10px",
        }}
      >
        {HeaderPage()}
        <DataTable
          exportButton={false}
          columns={columns}
          data={filteredItems}
          width="100%"
          countRowData={filteredItems.length}
          pageSize={pageSize}
        />
      </Card>
      {openDialogformEdit && (
        <AddUserData
          onCancel={() => setOpenDialogFormEdit(false)}
          open={openDialogformEdit}
          empId={empId}
        />
      )}
      {openDialogformAdd && (
        <AddUserData
          onCancel={() => setOpenDialogFormAdd(false)}
          open={openDialogformAdd}
          empId={null}
        />
      )}
      <Loading open={loading} />
    </>
  );
}

export default UserData;
